import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToSection } from "../lib/scroll";
import { NAV_LINKS } from "../lib/navLinks";

const Heading = ({ children }) => <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">{children}</p>;

const FooterNav = () => (
  <div>
    <Heading>Navigation</Heading>
    <div className="mt-4 flex flex-col items-start gap-2.5">
      {NAV_LINKS.map((l) => (
        <button key={l.id} data-testid={`footer-link-${l.id}`} onClick={() => scrollToSection(l.id)} className="text-sm font-medium text-white/70 transition-colors hover:text-gold">
          {l.label}
        </button>
      ))}
    </div>
  </div>
);

const FooterContacts = () => (
  <div>
    <Heading>Coordonnées</Heading>
    <div className="mt-4 flex flex-col gap-3">
      <a data-testid="footer-phone-link" href="tel:+33784678802" className="flex items-center gap-2.5 text-sm font-medium text-white/70 transition-colors hover:text-gold">
        <Phone size={15} className="text-gold" /> 07 84 67 88 02
      </a>
      <a data-testid="footer-email-link" href="mailto:site.com@outlook.fr" className="flex items-center gap-2.5 text-sm font-medium text-white/70 transition-colors hover:text-gold">
        <Mail size={15} className="text-gold" /> site.com@outlook.fr
      </a>
    </div>
  </div>
);

export const Footer = () => (
  <footer className="border-t border-white/10 bg-navy-dark">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-5 text-sm leading-relaxed text-white/60">
            Des sites internet professionnels pour les commerces, artisans, avocats, agents immobiliers, professions libérales et indépendants.
          </p>
        </div>
        <FooterNav />
        <FooterContacts />
      </div>
      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
        <div className="text-center text-xs text-white/50 sm:text-left">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} site.com — Création de sites internet pour professionnels</p>
          <p className="mt-1" data-testid="footer-legal">
            site.com est une entreprise immatriculée en France — SIRET 130 962 632 00019 · Sites hébergés chez OVHcloud
          </p>
          <p className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1 sm:justify-start">
            <Link to="/mentions-legales" className="font-semibold text-white/70 transition-colors hover:text-gold" data-testid="footer-link-mentions">Mentions légales</Link>
            <Link to="/confidentialite" className="font-semibold text-white/70 transition-colors hover:text-gold" data-testid="footer-link-privacy">Politique de confidentialité</Link>
          </p>
        </div>
        <p className="font-display text-sm font-bold text-white/50">
          site<span className="text-gold">.</span>com
        </p>
      </div>
    </div>
  </footer>
);
